import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { PrimeNGConfig } from 'primeng/api';
import { RippleModule } from 'primeng/ripple';
import { SidebarModule } from 'primeng/sidebar';
import { SpeedDialModule } from 'primeng/speeddial';
import { SidebarService } from './services/menu/sidebar.service';
import { SocketService } from './services/socket.service';
import { ToolOverlayComponent } from './components/molecules/tool-overlay/tool-overlay.component';
import { ToastModule } from 'primeng/toast';
import { ThemeCssClass } from './components/atoms/theme-switcher/theme-switcher.component';
import { CookieConsentComponent } from './components/organisms/cookie-consent/cookie-consent.component';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import './patches/quill-nbsp-fix';
import { TrackingService } from './services/tracking/tracking.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    CardModule,
    ButtonModule,
    RippleModule,
    SidebarModule,
    SpeedDialModule,
    ToolOverlayComponent,
    ToastModule,
    CookieConsentComponent,
    ConfirmDialogModule,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  title = 'Kommunal Atlas';
  localStorage: Storage | undefined;

  constructor(
    private primengConfig: PrimeNGConfig,
    protected sidebarService: SidebarService,
    private socketService: SocketService,
    private trackingService: TrackingService // Trigger initialization
  ) {
    this.localStorage = document.defaultView?.localStorage;
  }

  async ngOnInit() {
    // activate ripple-effect for all buttons
    this.primengConfig.ripple = true;
    const activeTheme = (this.localStorage?.getItem('hyperion-theme') ||
      'hyperion-light') as ThemeCssClass;
    document.documentElement.className = activeTheme; // Update HTML class

    // init sockets todo - not implemented yet
    //this.socketService.initializeSocketConnection();
  }
}
